import script from "./SectionList.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionList.vue?vue&type=script&setup=true&lang=js"

import "./SectionList.vue?vue&type=style&index=0&id=1f8d3a26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8d3a26"]])

export default __exports__